import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { JSONRpcResponse } from '../Interfaces/JSONRpcResponse'
import { JSONRpc } from './service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class CommunicationService {
	constructor(private http: HttpClient) { }

    getMessagesList(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.communication:getMessageList",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    getTypeCommunication(): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.communication:getTypeCommunication"
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
	
	getMessagePointList(id: string,type:string="courrier", options: any = []): Observable<JSONRpcResponse> {
	        let rpcMethod = new JSONRpc({
	            jsonrpc: "2.0",
	            method: "webservice.communication:getMessagePointList",
	            params: {
	                id: id,
					type: type,
	                options: options,
	            },
	        })
	        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	 }
	 
	 getMessageData(communicationid: string,id: string,type:string="courrier", options: any = []): Observable<JSONRpcResponse> {
	 	        let rpcMethod = new JSONRpc({
	 	            jsonrpc: "2.0",
	 	            method: "webservice.communication:getMessageData",
	 	            params: {
						commid: communicationid,
						id: id,
	 					type: type,
	 	                options: options,
	 	            },
	 	        })
	 	        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	  }
	 
	  setMessage(communicationid: string,id: string,type:string="courrier", options: any = []): Observable<JSONRpcResponse> {
	  	 	        let rpcMethod = new JSONRpc({
	  	 	            jsonrpc: "2.0",
	  	 	            method: "webservice.communication:setMessage",
	  	 	            params: {
	  						commid: communicationid,
	  						id: id,
	  	 					type: type,
	  	 	                options: options,
	  	 	            },
	  	 	        })
	  	 	        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	  	  }
	 
	 
}
